export default __webpack_public_path__ + "static/9-43d5d9a68e76a9ecafd737d0a99ac0a2.png";